<template>
  <div>
    <h1>Response</h1>
    <p>
      <v-btn :to="{name:'folder', params:{id:folderid}}" v-if="folderid">
        <v-icon>chevron_left</v-icon>Folder
      </v-btn>
    </p>
    <h3>Details</h3>
    <v-select
      v-model="folderid"
      :items="folders"
      item-value="id"
      item-text="name"
      label="Folder"
      outline
    />
    <!-- 
    <b:row>
      <b:column col-md="5">
        <h:outputText value="#{msg.response4}" />
      </b:column>
      <b:column col-md="7">
        <b:inputTextarea
          value="#{responseBean.response.body}"
          placeholder="#{msg.response5}"
          required="true"
          requiredMessage="#{msg.response6}"
          readonly="#{responseBean.id ne 0 and not responseBean.clone}"
        />
      </b:column>
    </b:row>
    <b:selectBooleanCheckbox
      value="#{responseBean.archive}"
      caption="#{msg.response9}"
      rendered="#{responseBean.clone}"
    />
    <b:commandButton
      action="#{responseBean.save}"
      value="#{msg.response8}"
      icon="chevron-right"
      iconAlign="right"
    >
      <f:ajax render="@form" execute="@form" />
    </b:commandButton>-->
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Response",
  metaInfo() {
    return {
      title: "Response",
      titleTemplate: "%s - Message - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      folders: null,
      response: null,
      folderid: null
    };
  },
  methods: {
    fetchFolders() {
      nbmlaw
        .get(`/cors/admin/message/folders`)
        .then(response => {
          // console.log(response.data);
          this.folders = response.data;
        })
        .catch(() => {});
    },
    fetchResponse() {
      nbmlaw
        .get(`/cors/admin/message/responses/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.response = response.data;
          this.folderid = this.response.folderId;
        })
        .catch(() => {});
    }
  },
  created() {
    this.fetchFolders();
    if (this.$route.params.id) {
      this.fetchResponse();
    }
    if (this.$route.query.folderid) {
      this.folderid = this.$route.query.folderid;
    }
  }
};
</script>